import InsertCommentIcon from '@mui/icons-material/InsertComment';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { useHasPreDiningExperienceFeatureFlag } from 'reservations/account/hooks/featureFlags';

type Props = {
  onClick: (...args: any[]) => any;
};

export const AddNoteButton = ({ onClick }: Props) => {
  const preDiningFeatureFlag = useHasPreDiningExperienceFeatureFlag();

  return preDiningFeatureFlag ? (
    <Typography onClick={onClick}>+ ADD A NOTE</Typography>
  ) : (
    <Button variant="text" onClick={onClick} startIcon={<InsertCommentIcon />}>
      ADD A NOTE
    </Button>
  );
};
